import { HiBuildingOffice } from "react-icons/hi2";

import Avatar from "@/components/atoms/Avatar";
import FeaturedIcon from "@/components/atoms/FeaturedIcon";

export type CompanyLogoProps = {
  url: string | null;
  size?: "sm" | "md";
};

const CompanyLogo = ({ url, size = "sm" }: CompanyLogoProps) => {
  return (
    <Avatar
      size={size}
      imageUrl={url}
      color={"primary"}
      showTitle={false}
      fallbackElement={<CompanyFallbackLogo size={size} />}
    />
  );
};

type CompanyFallbackLogoProps = {
  size?: "sm" | "md";
};
const CompanyFallbackLogo = ({ size = "sm" }: CompanyFallbackLogoProps) => {
  return <FeaturedIcon icon={HiBuildingOffice} color={"primary"} size={size === "sm" ? "xs" : "sm"} />;
};

export default CompanyLogo;
